import React, { FC } from "react";
import { DropdownFaq } from "../common/dropdown/DropdownFaq";
import { LmsFaqContainer } from "./LmsContainerFaq";
import LmsContactUs from "./LmsContactUs";

/**
 * LMS Frequently Asked Question section component.
 */
export const LmsFaqSection: FC = () => {
    return (
        <LmsFaqContainer id="faq">
            <div className="flex flex-wrap px-5 md:px-16">
                <div className="flex flex-col mx-auto text-center mt-4 mb-4 md:mt-8 md:mb-8 items-center">
                    <h2 className="text-slate-900 text-4xl font-body font-semibold align-center">Frequently Asked Questions</h2>
                    <div className='border-2 md:border-4 border-accent-100 rounded-full w-40 mt-3 md:mt-5' />
                    <div className="max-w-4/5 my-20 mx-10 md:mx-20">
                        <DropdownFaq question="Apa saja lembaga yang cocok menggunakan LMS?" answer="Lembaga pelatihan (training) dan pendidikan (sekolah, les, kursus)" />
                        <DropdownFaq question="Apakah bisa mengajukan fitur-fitur program tertentu saja?" answer="Iya, bisa untuk mengajukan fitur-fitur sesuai kebutuhan lembaga" />
                        <DropdownFaq question="Apakah bisa mengajukan kebutuhan jasa dan admin konsultan saja, bukan membuat LMS?" answer="Iya bisa, langsung konsultasi ke admin WA ya" />
                        <DropdownFaq question="Apakah setiap data anggota kelas dan materi kelas dapat diunggah ke LMS ini?" answer="Ya, bisa. Seluruh anggota kelas akan terdaftar di LMS dan memiliki kelasnya masing-masing, sedangkan materi kelas dapat diunggah dengan berbagai tipe file (Video, foto, dokumen, dan tulisan)" />
                        <DropdownFaq question="Apakah LMS bisa diakses melalui seluler?" answer="Ya, bisa menggunakan Google Chrome, Safari, dan sarana internet lainnya" />
                        <DropdownFaq question="Apakah layanan ini menjamin garansi?" answer="Tergantung dari paket yang dipilih oleh perusahaan" />
                        <DropdownFaq question="Bagaimana cara untuk konsultasi??" answer="Menghubungi admin melalui WhatsApp, Email, dan sosial media" />
                        <DropdownFaq question="Dimana bisa berkonsultasi?" answer="Konsultasi bisa dilakukan secara online dan offline, tetapi mohon menghubungi nomor WA admin yang tertera" />
                    </div>
                    <div className="flex flex-col mx-auto text-center mb-4 md:mb-16 items-center">
                        <p className="text-slate-900 text-2xl font-body font-semibold align-center mb-5">KONSULTASI LEBIH LANJUT?</p>
                        <LmsContactUs useCustomStyles={true} />
                    </div>
                </div>
            </div>
        </LmsFaqContainer>
    );
}